import { render } from "./exited-employee.vue?vue&type=template&id=f2028090"
import script from "./exited-employee.vue?vue&type=script&lang=js"
export * from "./exited-employee.vue?vue&type=script&lang=js"

import "./exited-employee.vue?vue&type=style&index=0&id=f2028090&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__